define('lib/utils',['require','jquery','underscore','chaplin','config/application','config/environment','mediator'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Chaplin = require('chaplin'),
        applicationConfig = require('config/application'),
        environmentConfig = require('config/environment');

    var utils = Chaplin.utils.beget(Chaplin.utils);

    var consts = {
        MONTHS: ['Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня', 'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'],
        MONTHS_SHORT: ['Янв', 'Фев', 'Мар', 'Апр', 'Мая', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        DAYS: ['Воскресение', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        DAYS_SHORT: ['Пн.', 'Вт.', 'Ср.', 'Чт.', 'Пт.', 'Сб.', 'Вс.']
    };

    _.mixin({
      compactObject: function(o) {
            _.each(o, function(v, k) {
                if (!v && typeof v !== 'boolean') {
                    delete o[k];
                }
            });
            return o;
        }
    });

    _.extend(utils, {
        fmtDate: function (date) {
            if (!_.isDate(date)) {
                date = new Date(date);
            }
            return [date.getFullYear(), ('0'+(date.getMonth()+1)).slice(-2), ('0'+date.getDate()).slice(-2)].join('-');
        },

        fmtDisplayDate: function (time, isShort, addWeekDay) {
            var date = new Date(), value;
            date.setTime(time);
            if (isShort) {
                value = [ date.getDate(), consts.MONTHS_SHORT[date.getMonth()] ];
            } else {
                value = [ date.getDate(), consts.MONTHS[date.getMonth()], date.getFullYear() ];
            }

            value = value.join(' ');

            if (addWeekDay) {
                value = value + ', ';
                if (isShort) {
                    value = value + consts.DAYS_SHORT[date.getDay()];
                } else {
                    value = value + consts.DAYS[date.getDay()];
                }
            }

            return value;
        },

        addDays: function (date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        },

        parseDate: function(str) {
            if (str instanceof Date && isFinite(str)) {
                return str;
            }

            var timestamp = Date.parse(str);

            if (!isNaN(timestamp)) {
                return new Date(timestamp);
            }
        },

        fmtDisplayDateTrade: function (value) {
            var date = new Date(value);
            var months = consts.MONTHS;
            return [ date.getDate(), months[date.getMonth()] ].join(' ');
        },

        // dayIndex - 0 its a Monday
        decodeDayName: function(dayIndex){
            var index = (dayIndex === 6) ? 0 : dayIndex + 1;
            return consts.DAYS[index];
        },

        date: function(date) {
            date = new Date(date);
            return [('0'+date.getDate()).slice(-2), ('0'+(date.getMonth()+1)).slice(-2), date.getFullYear()].join('.');
        },

        dateJs: function(date) {
            date = new Date(date);
            return [date.getFullYear(), ('0'+(date.getMonth()+1)).slice(-2), ('0'+date.getDate()).slice(-2)].join('-');
        },

        money: function(value, c, d, t) {
            if (!_.isNumber(value)) {
                value = 0;
            } else {
                if (Math.abs(value) === Infinity) {
                    value = 0;
                }
            }
            var i, j, s;
            c = isNaN(c = Math.abs(c)) ? 2 : c;
            d = (d === undefined) ? '.' : d;
            t = (t === undefined) ? ' ' : t;
            s = (value < 0) ? '-' : '';
            i = parseInt(value = Math.abs(+value || 0).toFixed(c)) + '';
            j = (j = i.length) > 3 ? j % 3 : 0;
            return s + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) + (c ? d + Math.abs(value - i).toFixed(c).slice(2) : '');
        },

        ajax: function(url, type, data) {
            return $.ajax({
                url: url,
                data: data || {},
                type: type || 'GET',
                dataType: 'json'
            });
        },

        get: function(url, query, headers) {
            return $.ajax({
                url: this.getApiUrl(url, query, true),
                type: 'GET',
                dataType: 'json',
                headers: headers
            });
        },

        post: function(url, query, data, headers) {
            return $.ajax({
                url: this.getApiUrl(url, query, true),
                data: data || {},
                type: 'POST',
                dataType: 'json',
                headers: headers
            });
        },

        delete: function(url, query, data) {
            return $.ajax({
                url: this.getApiUrl(url, query, true),
                data: data || {},
                type: 'DELETE',
                dataType: 'json'
            });
        },

        changeURL: function(action, params, query, options) {
            var url = Chaplin.mediator.execute('router:reverse', action, params, query);
            return Chaplin.mediator.execute('router:changeURL', url, options);
        },
        truncTime: function(date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
        },
        getApiRoot: function(){
            return environmentConfig[applicationConfig.environment].api.root;
        },
        getApiUrl: function(routeName, query, stripAccessToken){
            var accessToken, apiRoot, mediator, full, queryStr, sep, url;

            apiRoot = this.getApiRoot();

            if (!stripAccessToken) {
                mediator = require('mediator');
                if (mediator.user) {
                    accessToken = mediator.user.get('accessToken');
                }
            }

            if (accessToken) {
                if (!query) { query = {}; }
                /*jshint camelcase: false */
                query.access_token = accessToken;
            }

            full = apiRoot + routeName;
            queryStr = utils.queryParams.stringify(query);

            if (queryStr) {
                sep = (full.indexOf('?') >= 0) ? '&' : '?';
                url = full + sep + queryStr;
            } else {
                url = full;
            }
            return url;
        },

        popover: function ($el, title, fn) {

            var options = {
                placement: 'left',
                trigger: 'manual',
                // title: '<span>' + title + '</span><button style="padding-left: 8px;" type="button" class="close" aria-hidden="true" data-action="cancel">×</button>',
                container: 'body',
                html: true,
                content: _.isString(fn) ? fn : '<i class="icon-refresh icon-spin"></i><span> Загрузка</span>',
                template: '<div class="popover popover-black"><div class="arrow"></div><div class="popover-inner"><div class="popover-content"></div></div></div>'
            };

            if (_.isObject(title)) {
                _.assign(options, title);
            } else {
                options.title = title;
            }

            $el.popover('destroy').popover(options).popover('show');

            var popover = $el.data('popover');

            setTimeout(function() {
                $(window).one('click', function() {
                    if (popover) {
                        popover.destroy();
                        popover.tip().remove();
                    }
                    // $el.popover('destroy');
                });
            }, 20);

            if (_.isFunction(fn)) {
                fn(function (content){
                    var $content;
                    var data = $el.data('popover');
                    if (data) {
                        $content = $(data.$tip.find('.popover-content'));
                        if (_.isString(content)) {
                            $content.html(content);
                        } else {
                            $content.children().remove();
                            $content.append(content);
                        }
                    }
                });
            }
        },

        isEmail: function(email) {
            //TODO make more complex
            var regex = /^(\S+)@([a-z0-9\-]+)(\.)([a-z]{2,4})(\.?)([a-z]{0,4})+$/;
            return regex.test(email);
        },

        objectToCSS: function(obj) {
            var arr = _.map(obj, function(value, key) { return [key, value].join(': '); } );
            return arr ? arr.join('; ') : '';
        },

        fileSize: function(bytes, si) {
            var thresh = si ? 1000 : 1024;
            if (bytes < thresh) { return bytes + ' Б'; }
            //var units = si ? ['kB','MB','GB','TB','PB','EB','ZB','YB'] : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
            var units = si ? ['kB','MB','GB','TB','PB','EB','ZB','YB'] : ['КБ','МБ','ГБ','ТБ','PiB','EiB','ZiB','YiB'];
            var u = -1;
            do {
                bytes /= thresh;
                ++u;
            } while(bytes >= thresh);
            return bytes.toFixed(1)+' '+units[u];
        },

        unitToText: function(unit) {
            var str = ['шт.', 'гр.', 'пучок', 'банч'];
            return str[parseInt(unit, 10)] || '';
        },

        unitToText2: function(unit) {
            var map = {
                'piece': 'шт.',
                'gram': 'гр.',
                'beam': 'пучок,',
                'bunch': 'банч'
            };
            return map[unit] || '';
        },
        datetime: function(date) {
            date = new Date(date);
            return [('0'+date.getDate()).slice(-2), ('0'+(date.getMonth()+1)).slice(-2), date.getFullYear()].join('.') + ' ' +
                   [('0'+date.getHours()).slice(-2), ('0'+(date.getMinutes())).slice(-2), ('0'+date.getSeconds()).slice(-2)].join(':');
        },

        transformMessage: function(text) {
            var proto = /(https?:\/\/)|(ftp:\/\/)|(malito:\/\/)/i;
            var dots = /(^[\S]{20})[\S]*([\S]{10}$)/gi;
            var url = /(?:(?:https?:\/\/)|(?:www\.))[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,100}\b(?:[-a-zA-Z0-9@:%_\+.~#?&\/=]*)/gi;
            var img = /(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*\.(?:jpe?g|gif|png|svg))(?:\?([^#]*))?(?:#(.*))?/i;
            var breaks = /\n/g;

            function shortenUrl(text) {
                text = text.replace(proto, '');
                if (text.length > 50) {
                    text = text.replace(dots, '$1...$2');
                }
                return text;
            }

            return text.replace(breaks, '<br>').replace(url, function(s) {
                if (img.test(s)) {
                    return '<img src="' + s + '">';
                } else {
                    return '<a href="' + s + '" target="_blank">' + shortenUrl(s) + '</a>';
                }
            });
        },

        prepareSearch: function(items, fields) {
            var i, j, item, name, values;
            for (i=items.length; i--;) {
                item = items.at ? items.at(i) : items[i];

                values = [];
                for (j=fields.length; j--;) {
                    name = fields[j];

                    values.push(('' + (item.get ? item.get(name) : item[name]) || '').replace(/^\s+|\s+$/g, ''));
                }

                if (item.set) {
                    item.set('searchString', values.join(' ').toLowerCase(), { silent: true });
                } else {
                    item.searchString = values.join(' ').toLowerCase();
                }
            }
            return items;
        },
        applySearch: function(items, search) {
            var i, li, result, item;

            search = search && search.replace(/^\s+|\s+$/g, '');

            if (!search) {
                return items;
            }

            search = search.toLowerCase();

            result = [];

            for (i=0, li = items.length; i<li; i++) {
                item = items[i];
                if (item.searchString.indexOf(search) > -1) {
                    result.push(item);
                }
            }

            return result;
        }

    });

    return utils;
});

